import { largeCurrencyFormat } from 'common/formats/formats';
import GridRowLabel from 'components/Grid/GridRowLabel';
import { CashFlowSummaryColumnDefinition } from './types';

const grossIRRFormat = {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  isDecimal: true,
  validateFloat: true,
};

export const CASH_FLOW_SUMMARY_COLUMN_CONFIG = {
  valueViewer: (props: any) => <GridRowLabel {...props} />,
  className: 'table-header division-bottom-only text-right',
};

export const getCashFlowSummaryColumns = (): CashFlowSummaryColumnDefinition[] => [
  {
    alias: 'fund_name',
    value: 'Fund',
    gridType: 'string',
    dbType: 'string',
    readOnly: true,
    className: 'show-tooltip',
  },
  {
    alias: 'investments',
    value: 'Total Investments',
    gridType: 'number',
    dbType: 'string',
    format: largeCurrencyFormat,
    readOnly: true,
    className: 'text-align-right',
  },
  {
    alias: 'proceeds',
    value: 'Total Proceeds',
    gridType: 'number',
    dbType: 'string',
    format: largeCurrencyFormat,
    readOnly: true,
    className: 'text-align-right',
  },
  {
    alias: 'total',
    value: 'Net Cost Basis',
    gridType: 'number',
    dbType: 'string',
    format: largeCurrencyFormat,
    readOnly: true,
    className: 'text-align-right',
  },
  {
    alias: 'gross_irr',
    value: 'Gross IRR',
    gridType: 'percentage',
    dbType: 'number',
    format: grossIRRFormat,
    readOnly: true,
    className: 'text-align-right',
  },
];
